/**
 * 外呼上报函数
 */
import { Platform } from 'react-native'
import { JDLogin, JDNetwork } from '@jdreact/jdreact-core-lib'
import qs from 'query-string'
import { WebIsLogin, WebToLogin } from '../../utils/ut.web'



export default ({
  success = () => {},
  reportParams = {}
}) => {
  // 没有上报参数不做处理
  if(Object.keys(reportParams).length == 0) return

  // APP 走京东登录的逻辑
  if(Platform.OS !== 'web') {
    JDLogin.isLogin().then(() => {
      // 已经登录的，直接走上报逻辑
      doReport({ reportParams, success })
    }, _ => {
      // 未登录走发起登录逻辑
      JDLogin.doLogin().then(() => {
        // 登录成功
        doReport({ reportParams, success })
      }, () => {/* 用户不同意登录。不处理 */})
    })
  } else {
    // web走web的登录判断逻辑
    WebIsLogin().then(() => {
      // 已经登录的，直接走上报逻辑
      doReport({ reportParams, success })
    }).catch(() => {
      // 未登录走发起登录逻辑
      const { url, query } = qs.parseUrl(location.href)
      query['isReport'] = 1
      // 去登录
      WebToLogin(`${url}?${qs.stringify(query)}`)
    })
  }

  // 发起上报
  function doReport({
    reportParams = {},
    success = () => {},
  }) {
    doRequest(reportParams).then(res => {
      const { code, msg } = res
      // 接口请求成功
      if (code == '0000') {
        console.log('提交成功')
      } else if(code == '1023') {
        console.log('用户未登录')
      } else if (code == '15022') {
        console.log('心愿单当日提交已达上限，请勿重复提交')
      } else if (code == '15023') {
        console.log('心愿单总提交已达上限，请勿重复提交')
      } else {
        console.log('其他问题: ' + msg)
      }
      success()
    }).catch(e => {
      console.log(e)
    })
  }

  // 发起不同请求
  function doRequest(reportParams) {
    let host = 'https://api.m.jd.com/api?functionId='
    // web请求
    if(Platform.OS == 'web') {
      return fetch(`${host}insertWish&appid=wishplat&body=${encodeURIComponent(JSON.stringify(reportParams))}`, {
        credentials: 'include'
      }).then(res => res.json())
    }
    
    if (Platform.OS === 'android') {
      host = 'api.m.jd.com';
    }

    const Referer = reportParams.wishSourceUrl || 'https://esfr.m.jd.com'
    const requestObj = {
      "function_id": "insertWish",
      "host": host,
      "host_beta": host,
      "params": { "appid": "wishplat" },
      "head": { "Referer": Referer },
      "params_json": JSON.stringify(reportParams),
    }

    return JDNetwork.fetchWithSignAndHead(requestObj)
  }
}